import * as React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import styled from "@emotion/styled";
import CancelIcon from "@mui/icons-material/Cancel";
import ItemOption from "./ItemOption";
export interface I_MENU_OPTIONS {
  label?: string;
  icon?: string | any;
  onClick?: (x: I_MENU_OPTIONS) => void;
  buttonComponent?: React.ReactNode;
  extraHiddenComponent?: React.ReactNode;
  id?: string;
  show?: boolean;
}

interface MenuProps {
  children?: React.ReactNode;
  wrapperItems?: React.ReactNode;
  items: I_MENU_OPTIONS[];
  msgTooltip?: string;
  id?: string;
  row?: number;
}

export default function MenuOptions(props: MenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickItem = (x: any) => {
    if (x.onClick) {
      x.onClick(x);
      return;
    }
  };

  return (
    <React.Fragment>
      <Box
        sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {/* <Tooltip title={props?.msgTooltip}> */}
        {/* {React.cloneElement(props.children as React.ReactElement, {
          onClick: handleClick,
          "aria-haspopup": true,
          "aria-expanded": open ? "true" : undefined,
          className: "pointer",
        })} */}

        {props.children}

        {/* </Tooltip> */}
      </Box>
      <CustomMenu
        rows={props?.row ?? 1}
        style={{ width: "400px" }}
        anchorEl={anchorEl}
        id={props?.id ?? "account-menu"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={styles}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.items.map((x: any) => (
          <CustomMenuItem
            className="menu-item"
            key={window.crypto.randomUUID()}
            onClick={x.onClick ? () => onClickItem(x) : undefined}
          >
            {x.buttonComponent ? x.buttonComponent : <ItemOption {...x} />}
          </CustomMenuItem>
        ))}
      </CustomMenu>
    </React.Fragment>
  );
}

const Close = styled(CancelIcon)`
  height: 18px;
  color: var(--m-color-red-01);
`;

const CustomMenuItem = styled(MenuItem)`
  width: auto;
`;
const CustomMenu = styled(Menu)<{ rows: number }>`
  * {
    cursor: pointer;
  }
  & ul {
    display: grid;
    grid-template-columns: repeat(${props => props.rows}, 1fr);
    align-items: center;
    padding: 10px;
    gap: 10px;
    li {
      padding: 0px !important;
    }
  }
`;

const styles = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0
    }
  }
};
